import EndConversationConfirmation from './end-conversation-confirmation';

export default function (app, done) {
  const endConversationConfirmation = new EndConversationConfirmation(app);
  Object.assign(app, {
    endConversationConfirmation,
  });
  endConversationConfirmation.on('load', () => {
    done();
  });
}



// WEBPACK FOOTER //
// ./src/app/module/end-conversation-confirmation/index.js